import { useEffect, useState } from 'react';
import Button from '@atoms/Button';
import ButtonType from '@atoms/Button/type';
import classNames from 'classnames';

import { ReactComponent as ArrowRight } from '@icons/arrow-right.svg';

export interface PagerProps {
  totalPages: number;
  currentPage: number;

  onPageChange?(newPage: number): void;
}

// import { InlineSvg } from 'images/InlineSvg';

// const ArrowRight = ({ className }: { className?: string }) => (
//   <InlineSvg svgContent={_ArrowRight} className={className} />
// );

const Pager = ({ totalPages, currentPage, onPageChange }: PagerProps) => {
  const [page, setPage] = useState<number>(currentPage);

  useEffect(() => {
    if (currentPage !== page) {
      setPage(currentPage);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [currentPage]);

  const updatePage = (newPage: number) => {
    if (newPage === page) {
      return;
    }

    setPage(newPage);
    if (typeof onPageChange === 'function') {
      onPageChange(newPage);
    }
  };

  const numberButtons = new Array(totalPages).fill(null).map((value, index) => {
    const active = index === page - 1;
    const buttonClasses = classNames('h-8', 'h-8', {
      'rounded-tl-xl rounded-bl-xl': !index,
      'rounded-tr-xl rounded-br-xl': index + 1 === totalPages,
      'pointer-events-none': active,
    });
    return (
      <Button
        /* eslint-disable-next-line react/no-array-index-key */
        key={index}
        className={buttonClasses}
        type={ButtonType.PAGER}
        active={active}
        onClick={() => updatePage(index + 1)}
      >
        {index + 1}
      </Button>
    );
  });

  return (
    <div className="flex items-center mt-8 select-none">
      <Button
        className="rounded-xl h-8 !mr-2"
        type={ButtonType.PAGER}
        onClick={() => updatePage(page - 1)}
        disabled={page === 1}
      >
        <ArrowRight className="transform rotate-180" />
      </Button>
      {numberButtons}
      <Button
        className="rounded-xl h-8 !ml-2"
        type={ButtonType.PAGER}
        onClick={() => updatePage(page + 1)}
        disabled={page === totalPages}
      >
        <ArrowRight />
      </Button>
    </div>
  );
};

export default Pager;
